import {  Outlet, useLocation } from "react-router-dom";
import Navigastion from "../../Modules/Components/Navigation";
import { USER_CURRENT_PATH } from "../../helpers/common";
import BackBtnLeft from "../../icons/BackBtnLeft";

const UserValidator = () => {
  const location = useLocation();
  const cleanedPath = location.pathname.replace(/^\/|\/$/g, "");
  return (
    <>
      <div className={`app_bg ${cleanedPath}`}>
        <div className="container">
          <Navigastion />
          {/* {(window.location.pathname !== USER_CURRENT_PATH.HOME) && <BackBtnLeft />} */}
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default UserValidator;
